import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

import { RootDiv, Wrap, Button, Icon, QtyBadge, QtyTxt } from './styled';

const MAX_ITEMS_VALUE = 100;
const MAX_VALUE_TEXT = '99+';

const CounterButton = ({
    className,
    isDesktopUser,
    showOverlay,
    handleMouseEnter,
    handleMouseLeave,
    theme,
    cart,
}) => {
    const totalCartItemsQty =
        cart && cart.items && cart.items.reduce((total, item) => total + item.quantity, 0);

    return (
        <RootDiv className={className} onClick={showOverlay} data-testid="counter-button">
            <Wrap
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                isClickable={!isDesktopUser}
            >
                <Button>
                    <Icon color={theme.colors.Foreground} />
                </Button>
                {totalCartItemsQty > 0 && (
                    <QtyBadge>
                        <QtyTxt tag="label">
                            {totalCartItemsQty < MAX_ITEMS_VALUE
                                ? totalCartItemsQty
                                : MAX_VALUE_TEXT}
                        </QtyTxt>
                    </QtyBadge>
                )}
            </Wrap>
        </RootDiv>
    );
};

CounterButton.propTypes = {
    className: PropTypes.string,
    cart: PropTypes.shape({
        items: PropTypes.array,
    }),
    isDesktopUser: PropTypes.bool,
    showOverlay: PropTypes.func,
    handleMouseEnter: PropTypes.func,
    handleMouseLeave: PropTypes.func,
    theme: PropTypes.shape({
        colors: PropTypes.object,
    }).isRequired,
};

CounterButton.defaultProps = {
    className: '',
    cart: {},
    isDesktopUser: false,
    showOverlay: () => {},
    handleMouseEnter: () => {},
    handleMouseLeave: () => {},
};

export default withTheme(CounterButton);
